/**
 * @group Constants
 * @summary
 * <blockquote>Enumerates the supported runtime targets: browser, server, and mobile.</blockquote>
 *
 * @example
 * ```typescript
 * import { RUNTIME_KINDS } from '@shared/core';
 *
 * if (runtimeKind === RUNTIME_KINDS.BROWSER) {
 *   // browser-specific initialisation
 * }
 * ```
 */
export const RUNTIME_KINDS = {
  BROWSER: 'browser',
  SERVER: 'server',
  MOBILE: 'mobile',
} as const;
